import { onConnect } from '@reatom/framework'

import { reatomRequest } from '@root/shared/lib'

import { getWikiSummaryRequestAction } from './get-wiki-summary-request-action'

export const wikiSummary = (options: { language: string; title: string }) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestModel = reatomRequest({
    execAction: getWikiSummaryRequestAction,
    prepare: () => ({
      language: options.language,
      title: options.title,
    }),
  })

  onConnect(requestModel, (ctx) => {
    requestModel.execute(ctx)
  })

  return { requestModel }
}
